import {ITableVerticalDataGroup} from './table-vertical-api-adapter';
import {DisplayedColumns} from '../table-control/interfaces/displayed-columns.interface';
import {IApiRow} from '../table-control/api-row.interface';
import {IApiCell} from '../table-control/api-cell.interface';
import {IApiControl} from '../../../../../../nucleus/src/lib/control/interfaces/api-control.interface';
import {IGroupMap} from '../../../../../../nucleus/src/lib/control/base-control-new/signal-control.directive';
import {TColType} from '../table-control/cell.enum';
import {DatePipe} from '@angular/common';

const datePipe: DatePipe = new DatePipe('de-DE');

export function mapRow(
  row: IApiRow,
  displayedColumns: DisplayedColumns[],
  apiInstance: IApiControl,
  groupMap: IGroupMap,
): ITableVerticalDataGroup[] {
  const groups: ITableVerticalDataGroup[] = [];
  const allColumnIndices: number[] = displayedColumns.map((c: DisplayedColumns, idx: number): number => idx);
  if (!groupMap) {
    groupMap = {
      '': allColumnIndices,
    };
  }

  for (const [name, colIndices] of Object.entries(groupMap)) {
    const group: ITableVerticalDataGroup = {name, rows: []};
    for (const [groupElementIdx, displayedColIdx] of colIndices.entries()) {
      const col: DisplayedColumns = displayedColumns[displayedColIdx];
      const cell: IApiCell = row.cols[Number(col.field)];

      let displayValue = cell.value;
      if (col.type === TColType.clTimeOfDay && cell.value) {
        displayValue = datePipe.transform(cell.value, 'HH:mm');
      }

      group.rows.push({
        type: col.type,
        attributeIndex: col.attributeindex,
        attribute: col.attribute,
        fieldName: col.headerName,
        value: displayValue,
        editable: cell.editable,
        apiRow: row,
        apiInstance: apiInstance,
        repository: col.repository,
        invalidMessage: cell.invalidmessage ? cell.invalidmessage : null,
        imported: cell.imported,
        index: groupElementIdx,
        hidden: cell.hidden || false,
      });
    }
    groups.push(group);
  }

  return groups;
}
